import { render, staticRenderFns } from "./ButtonDefault.vue?vue&type=template&id=5875ed2a"
import script from "./ButtonDefault.vue?vue&type=script&lang=js"
export * from "./ButtonDefault.vue?vue&type=script&lang=js"
import style0 from "./ButtonDefault.vue?vue&type=style&index=0&id=5875ed2a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports